import React from "react";
import FilterPanel from "@hyro-components/hyro-filter/components/filter-panel/FilterPanel";
import FilterButton from "@hyro-components/hyro-filter/components/filter-button/FilterButton";

const HyroFilter = ({
  button,
  panel,
  disabled,
  ...rest
}) => {
  if (button) {
    return (
      <FilterButton
        displayMode={rest.displayMode}
        disabled={disabled}
        filterOptions={rest.filterOptions}
        testId={rest.testId}
        onFilterOptionClick={rest.onFilterOptionClick}
      />
    );
  }

  if (panel) {
    return (
      <FilterPanel
        disabled={disabled}
        activeFilters={rest.activeFilters}
        inactiveFilters={rest.inactiveFilters}
        isBulkEditActive={rest.isBulkEditActive}
        handleChangeFilterField={rest.handleChangeFilterField}
        handleRemoveFilter={rest.handleRemoveFilter}
        handleClearAll={rest.handleClearAll}
        handleAddFilter={rest.handleAddFilter}
      />
    );
  }

  return null;
};

export default HyroFilter;
